import { Button, Tooltip } from 'antd'
import StatusFilter, { statusFilterMethod } from '../../../components/Sales/Orders/TableComponents/StatusFilter'
import DateCell from '../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import CustomTable from '../../../elements/Table/CustomTable'
import moment from 'moment/moment'
import React, { Fragment } from 'react'

import { Link, withRouter } from 'react-router-dom'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import { compose, withState } from 'recompose'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import Status from '../../../elements/Status'
import { dateFormat, formatQueryParams, moneyColumn, numVal } from '../../../modules/Utils'

const CheckboxTable = checkboxHOC(CustomTable)

function OrdersList(props) {
  const {
    fetching,
    fetch,
    tableRef,
    list,
    onChangeCompany,
    company,
    toggleSelection,
    toggleAll,
    selectAll,
    selection,
    isSelected,
    invoiceComboOrders,
    fetchingLines,
    contract,
    hideCompany,
    enquiryID,
    quoteID,
  } = props

  //console.log(enquiryID)
  const checkboxProps = {
    selectType: 'checkbox',
    toggleSelection,
    isSelected,
    toggleAll,
    selectAll,
    selection,
  }
  const columns = [
    {
      Header: 'Code',
      accessor: 'code',
      Cell: ({ original, value }) => (
        <Link
          target={props.contract && '_blank'}
          to={{
            pathname: `/clients/orders/${original._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'Enquiry',
      accessor: 'enquiry.code',
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: ({ value }) => value && dateFormat(moment(value)),
    },
    {
      Header: 'Client',
      accessor: 'client.fn',
      width: 300,
    },
    {
      Header: 'Account',
      accessor: 'contract.code',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Currency',
      accessor: 'currency',
      hideable: true,
      hideDefault: true,
      style: { textAlign: 'center' },
    },
    // {
    //   Header: 'Amount',
    //   accessor: 'subtotal.net',
    //   hideable: true,
    //   hideDefault: true,
    //   style: {textAlign: 'right'},
    //   Cell: MoneyCell,
    // },
    {
      Header: 'Company',
      accessor: 'company.fn',
      hideDefault: true,
      hideable: true,
      width: 400,
    },
    {
      Header: 'totalUnit',
      accessor: 'totalUnit',
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'totalDelivered',
      accessor: 'totalDelivered',
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Title',
      accessor: 'title',
      hideDefault: true,
      hideable: true,
      width: 400,
    },

    {
      Header: 'Invoiced',
      accessor: 'invoicing.status',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'delivered',
      accessor: 'delivered',
      Cell: ({ original }) =>
        <Tooltip title={`Total Unit: ${original.totalUnit}, Total Delivered: ${original.totalDelivered}`}>
          {original.totalUnit - original.totalDelivered === 0 ? 'Shipped' : 'Part Shipped'}
        </Tooltip>,
    },
    {
      Header: 'Requisitioned',
      accessor: 'requisitioning.status',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Invoiced Date',
      accessor: 'invoicing.date',
      Cell: DateCell,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Delivery Date',
      accessor: 'delivery.date',
      Cell: DateCell,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'CPO NO',
      accessor: 'cpo.no',
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Quote Code',
      accessor: 'quote.code',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Reference NO',
      accessor: 'reference.no',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Value (Net)',
      accessor: 'subTotal.net',
      Cell: ({ value }) => moneyColumn(numVal({ value }, 'value')),
      style: { textAlign: 'right' },
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: 150,
      Cell: StatusCell,
      filterMethod: statusFilterMethod,
      Filter: StatusFilter,
    },
    // {
    //   Header: 'File',
    //   accessor: 'file',
    //   Cell: ({value}) =>
    //     value && (
    //       <ViewDownload
    //         view={`${streamUrl}files/${value}?action=view&access_token=${auth.getAccessToken()}`}
    //         download={`${streamUrl}files/${value}?action=download&access_token=${auth.getAccessToken()}`}
    //       />
    //     ),
    // },
  ].map((c) => ({
    style: { textAlign: 'center' },
    ...c,
  }))

  const NewBookingButton = withRouter(({ history, contract, ...rest }) => {
    return (
      <Button
        type='primary'
        icon={'plus'}
        size={'small'}
        onClick={() => {
          history.push({
            pathname: '/clients/orders/new/',
            // search: contract ? `?contract=${contract || ''}` : '',
            search: `${formatQueryParams('enquiryID', enquiryID, true)}&${formatQueryParams('quoteID', quoteID, true)}`,
          })
        }}
        {...rest}>
        New Sales Order
      </Button>
    )
  })

  return (
    <Fragment>
      <CheckboxTable
        {...checkboxProps}
        CreateButton={() => <NewBookingButton contract={contract} style={{ marginRight: 10 }} />}
        ExtraButtons={() => (
          <Fragment>
            <Button
              style={{ marginRight: 10 }}
              onClick={invoiceComboOrders}
              size={'small'}
              disabled={selection.length === 0}
              loading={fetchingLines}
              icon={'file-protect'}>
              Invoice Combo Orders
            </Button>
          </Fragment>
        )}
        ExtraOptionsButtons={() =>
          hideCompany !== true && (
            <OrganisationsSelect
              onChange={onChangeCompany}
              value={company}
              placeholder={'Filter by a company'}
              size={'small'}
              style={{ width: '450px', paddingRight: 20, float: 'right' }}
            />
          )
        }
        fetch={fetch}
        columns={columns}
        data={list}
        fetching={fetching}
        withRef={tableRef}
        defaultPageSize={20}
        show={{ extraColumns: true }}
        defaultFiltered={[
          {
            id: 'status',
            value: true,
          },
        ]}
        isFilterable={true}
      />
    </Fragment>
  )
}

OrdersList.propTypes = {}
OrdersList.defaultProps = {
  fetching: false,
  fetch: () => console.error('Not Implemented'),
  list: [],
  selection: [],
}
export default compose(withState('filterable', 'setFilterable', true))(OrdersList)
